import {AuthProvider, useFirebaseApp} from 'reactfire';
import {connectAuthEmulator, getAuth} from 'firebase/auth';

export const ReactFireAuthProvider = ({children}: {children?: React.ReactNode}) => {
  const firebase = useFirebaseApp();
  const auth = getAuth(firebase);

  // Use the firebase emulator in dev-mode, or whenever this environment variable is set.
  // This will store any auth data on your local machine instead of in Firebase.
  const emulatorHost = process.env.NEXT_PUBLIC_FIREBASE_AUTH_EMULATOR_HOST;

  if (emulatorHost && !auth.emulatorConfig) {
    // When we are connected to localhost hide the message that warns us not to use the
    // emulator in production
    const disableWarnings = !!process.env.NEXT_PUBLIC_API_URL?.match('localhost');

    connectAuthEmulator(auth, emulatorHost, {disableWarnings});
  }

  return <AuthProvider sdk={auth}>{children}</AuthProvider>;
};
